// What a packet costs, read off the two prices the API returns for it.
//
// Both are amounts charged every month. `monthlyPrice` is the plan month to
// month. `annuallyPrice` is the same plan on a 12-month commitment: billed
// monthly too, at that rate, for the twelve months, and never once a year.
// Premium is 249 a month, or 199 a month on the annual plan. The backend made
// that the one meaning for every packet on 2026-10-14. Before that, Customer
// Feedback's annual price was a whole year's (320), and the cards told the two
// apart. So nothing here multiplies or divides by 12: the figure the API
// returns is the figure each month is charged, and the annual option is told
// apart by its terms, never by another period.

/** How the annual option is billed, said after its price: "$71/month, billed monthly, 12-month commitment". */
export const ANNUAL_BILLING_TERMS = "billed monthly, 12-month commitment";

/** The same terms on a line of their own, under the price. */
export const ANNUAL_BILLING_NOTE = "Billed monthly, 12-month commitment";

/** What a plan is charged each month on the option shown, annual or monthly. */
export const getPlanPrice = (plan, isYearly) => (isYearly ? plan?.annuallyPrice : plan?.monthlyPrice);

/** A price as the cards print it, or a dash when the packet carries none. */
export const formatPrice = (amount) =>
   typeof amount === "number" ? `$${amount.toLocaleString()}` : "—";

/** A plan's price with its terms: "$99/month", or "$71/month, billed monthly, 12-month commitment". */
export const describePlanPrice = (plan, isYearly) =>
   `${formatPrice(getPlanPrice(plan, isYearly))}/month${isYearly ? `, ${ANNUAL_BILLING_TERMS}` : ""}`;

// How long a packet's free trial runs. Each packet reports its own length
// (`trialDays`); nothing in the app states one of its own, because every number
// it ever stated was wrong.

/** A trial length as a card prints it — "30 days free" — or null for no trial. */
export const formatTrialDays = (trialDays) =>
   typeof trialDays === "number" && trialDays > 0
      ? `${trialDays} ${trialDays === 1 ? "day" : "days"} free`
      : null;

/** The trial every plan in a list shares, or null when they differ or have none. */
export const getSharedTrialDays = (plans) => {
   const lengths = [...new Set((plans ?? []).map((plan) => plan?.trialDays))];

   return lengths.length === 1 && typeof lengths[0] === "number" && lengths[0] > 0
      ? lengths[0]
      : null;
};
